<template>
    <div>
        <div v-if="getProgress < 100">
            <base-progress
                type="default"
                :value="getProgress"
                :label="$t('finishedplayers')"
            ></base-progress>
        </div>
  </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        data: function () {
            return {
            }
        },
        computed: {
            getProgress() {
                return this.$store.getters.howBigPercentageHaveDoneSurvey(this.$store.getters.getCurrentCaseNumber, false)
            }
        },
        mounted() {
        },
        methods: {
       }
    }
</script>
<i18n>
{
  "en": {
    "finishedplayers": "Answered"
  },
  "fi": {
    "finishedplayers": "Vastanneet"
  },
  "sv": {
    "finishedplayers": "De som svarat"
  },
  "de": {
    "finishedplayers": "Beantwortet"
  },
  "ko": {
    "finishedplayers": "응답완료"
  }
}
</i18n>
